import type { ReactNode } from 'react';

export const symbol_ev_mobiledata_badge: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h760q24 0 42 18t18 42v600q0 24-18 42t-42 18H100Zm0-60h760v-600H100v600Zm0 0v-600 600Zm310-100q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H260v-110h110q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H260v-110h150q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H230q-12.75 0-21.37 8.62Q200-662.75 200-650v340q0 12.75 8.63 21.37Q217.25-280 230-280h180Zm210-97-72-281q-2.36-9.86-10.21-15.93-7.86-6.07-18.86-6.07Q504-680 495-668t-5 26l88 337q2.87 11.21 12.43 18.1Q600-280 611-280h18q11 0 20.57-6.9 9.56-6.89 12.43-18.1l88-338q4-14-5.21-25.5T721-680q-10.97 0-18.81 6.34-7.84 6.35-10.19 16.66l-72 280Z"
		/>
	</svg>
);
